/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  GET_MESSAGES_DONE,
  GET_MESSAGES_FAILED,
  GET_MESSAGES_REQUEST,
  MessagesActionsType
} from 'store/action';

import {IMessage} from 'interfaces/messagesProps';
import {IPortalError} from 'utility/error-handler';

interface IMessagesByView {
  id: string;
  messages: IMessage[];
  hasMoreBefore: boolean;
  hasMoreAfter: boolean;
}

export interface IMessagesState {
  isFetching: boolean;
  error: null | IPortalError;
  channel: IMessagesByView;
  room: IMessagesByView;
}

const defaultState: IMessagesState = {
  isFetching: false,
  error: null,
  channel: {
    id: '',
    messages: [],
    hasMoreBefore: false,
    hasMoreAfter: false
  },
  room: {
    id: '',
    messages: [],
    hasMoreBefore: false,
    hasMoreAfter: false
  }
};
const messagesReducer: Reducer<Readonly<IMessagesState>, MessagesActionsType> = (state: IMessagesState = defaultState, action: MessagesActionsType) => {
  switch (action.type) {
    case GET_MESSAGES_REQUEST: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case GET_MESSAGES_DONE: {
      const {id, view, messages, hasMoreBefore, hasMoreAfter} = action.payload;

      return {
        ...state,
        isFetching: false,
        error: null,
        [view]: {
          messages,
          hasMoreBefore,
          hasMoreAfter,
          id
        }
      };
    }

    case GET_MESSAGES_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default messagesReducer;